import React, { Component } from 'react';
import { connect } from 'react-redux';

import 'react-big-calendar/lib/css/react-big-calendar.css';

import AddEventDialog from './OldEventsAmenities/AddEventDialog';
import BookAmenityDialog from './OldEventsAmenities/BookAmenityDialog';
import ViewEventDialog from './OldEventsAmenities/ViewEventDialog';

import ConfirmationDialog from 'components/shared/ConfirmationDialog';
import EventCalendarBasic from 'components/shared/EventCalendarBasic';

import * as landlordPropertiesActions from 'actions/landlordPropertiesActions';
import * as siteEventActions from 'actions/siteEventActions';

import FlatButton from 'material-ui/FlatButton';

import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

import CreateEvent from './Events/CreateEvent';
import EditEvent from './Events/EditEvent';

import { default as AntDrawer } from 'components/ui/Drawer';
import { RenderIfToggleOn, RenderIfToggleOff } from 'components/shared/ToggleRenderer';

import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';
import { StyledHeader } from 'helpers/StyledTableComponentsHelper';

import { getEvent } from './Events/store/actions';

let EventCalendar = class EventCalendar extends Component {
  state = {
    showAddDialog: false,
    showAmenityDialog: false,
    showEventDetailsDialog: false,
    createEventOpen: false,
    editEventOpen: false,
    eventDetails: {},
    confirmDelete: false,
    propertyIds: [],
    range: null,
  };

  UNSAFE_componentWillMount() {
    this.props.getProperties({ for_multiselect: true });
    this.props.clearEvents();
  }

  toggleAddEvent = (eventDetails) => {
    if (!this.state.showAddDialog) {
      let eventBreakdown = eventDetails;
      if (!eventDetails) {
        eventBreakdown = { show_to_tenants: true };
      }

      if (!eventBreakdown['properties']) {
        eventBreakdown['properties'] = [];
      }

      this.setState({
        eventDetails: eventBreakdown,
      });
    }

    this.setState({
      // old event form
      showAddDialog: !this.state.showAddDialog,
      // new event form
      createEventOpen: !this.state.createEventOpen,
    });
  };

  toggleAmenityPopup = () => {
    this.setState({
      showAmenityDialog: !this.state.showAmenityDialog,
    });
  };

  toggleEventDetails = (eventDetails) => {
    let eventDetail = eventDetails;
    if (eventDetail && eventDetail.is_calendar_hold) return;

    const isSiteEvent = eventDetail && eventDetail.event_type === 'SiteEvent';

    // if the feature toggle is on for event
    if (featureEnabled('ui.events.new_drawer') && isSiteEvent) {
      this.openEventDetails(eventDetail);
      return;
    }
    // feature toggle is off
    if (this.state.showEventDetailsDialog) {
      eventDetail = {};
    } else {
      this.props.clearEventDetails();
    }

    if (eventDetail.id) {
      this.props.getEventDetails(eventDetail.event_type, eventDetail.id);
    }
    this.setState({
      showEventDetailsDialog: !this.state.showEventDetailsDialog,
      eventDetails: eventDetail,
    });
  };

  openEventDetails = async (eventDetail) => {
    await this.props.getEvent(eventDetail.event_type, eventDetail.id);

    this.setState({
      editEventOpen: !this.state.editEventOpen,
      eventDetails: eventDetail,
    });
  };

  onPropertySelect = (properties) => {
    let propertyIds = [];
    if (properties.length > 0) {
      propertyIds = properties.map((property) => Number(property.value));
      this.props.getEvents(propertyIds, this.state.range);
    } else {
      this.props.clearEvents();
    }
    this.setState({ propertyIds });
  };

  deleteConfirmation = () => {
    this.setState({ confirmDelete: !this.state.confirmDelete });
  };

  deleteEvent = () => {
    let siteEventType = 'SiteEvent';
    let siteEventId = this.props.eventDetails.id;
    if (this.props.eventDetails.booking_id) {
      siteEventType = 'Bookable';
      siteEventId = this.props.eventDetails.booking_id;
    }
    this.props.deleteSiteEvent(siteEventType, siteEventId).then(() => {
      this.props.getEvents(this.state.propertyIds, this.state.range);
      this.deleteConfirmation();
      this.toggleEventDetails();
    });
  };

  onComplete = () => {
    if (!this.state.propertyIds.length > 0) {
      this.props.getEvents(this.state.propertyIds, this.state.range);
    }
  };

  closeViewEvent = () => {
    this.setState({
      createEventOpen: false,
      editEventOpen: false,
    });
  };

  handleRangeChange = (range) => {
    this.setState({
      range: range,
    });
    if (this.state.propertyIds.length === 0) {
      return;
    }
    this.props.getEvents(this.state.propertyIds, range);
  };

  render() {
    return (
      <div
        className="body"
        role="main"
        style={{
          marginTop: '55px',
          height: 'calc(100% - 55px)',
          paddingBottom: '15px',
        }}
      >
        <div className="centers">
          <div style={{ height: 'calc(100% - 150px)' }}>
            <BookAmenityDialog
              isOpen={this.state.showAmenityDialog}
              toggleDialog={this.toggleAmenityPopup}
              properties={this.props.properties}
              propertyIds={this.state.propertyIds}
              initialValues={this.state.eventDetails}
              onComplete={this.onComplete}
            />

            <ViewEventDialog
              isOpen={this.state.showEventDetailsDialog}
              toggleDialog={this.toggleEventDetails}
              toggleEditDialog={this.toggleAddEvent}
              eventDetails={this.props.eventDetails}
              editEvent={this.toggleAddEvent}
              deleteEvent={this.deleteConfirmation}
            />
            <RenderIfToggleOff toggle="ui.events.new_drawer">
              <AddEventDialog
                isOpen={this.state.showAddDialog}
                toggleDialog={this.toggleAddEvent}
                properties={this.props.properties}
                propertyIds={this.state.propertyIds}
                initialValues={this.state.eventDetails}
                toggleDetailsDialog={this.toggleEventDetails}
                onComplete={this.onComplete}
              />
            </RenderIfToggleOff>
            <RenderIfToggleOn toggle="ui.events.new_drawer">
              <AntDrawer
                maskClosable={false}
                keyboard
                visible={this.state.createEventOpen}
                onClose={this.toggleCreateEvent}
                closable={false}
                width={600}
              >
                {this.state.createEventOpen && <CreateEvent handleClose={this.closeViewEvent} />}
              </AntDrawer>

              <AntDrawer
                maskClosable={false}
                keyboard
                visible={this.state.editEventOpen}
                onClose={this.toggleCreateEvent}
                closable={false}
                width={600}
              >
                <EditEvent
                  handleClose={this.closeViewEvent}
                  onSubmissionComplete={() => {
                    this.props.getEvents(this.state.propertyIds, this.state.range);
                  }}
                />
              </AntDrawer>
            </RenderIfToggleOn>
            <div
              style={{
                marginBottom: '25px',
                display: 'flex',
                justifyContent: 'space-betwen',
              }}
            >
              <StyledHeader>
                <HeaderWithPeriod
                  headerText={getTranslatedString('landlordPortal.calendarPage.calendar')}
                  newStyle
                />
              </StyledHeader>
              <div style={{ marginRight: '12px' }}>
                <FlatButton
                  label={getTranslatedString('landlordPortal.amenities.bookButton')}
                  type="submit"
                  primary={true}
                  backgroundColor={AccentColor()}
                  hoverColor="grey"
                  onClick={this.toggleAmenityPopup}
                  style={{
                    color: 'white',
                    float: 'right',
                    height: '30px',
                    fontSize: '13px',
                    lineHeight: '30px',
                    marginTop: '3px',
                  }}
                />
              </div>
              <FlatButton
                label={getTranslatedString('landlordPortal.calendarPage.addEvent')}
                type="submit"
                primary={true}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                onClick={this.toggleAddEvent}
                style={{
                  color: 'white',
                  float: 'right',
                  height: '30px',
                  fontSize: '13px',
                  lineHeight: '30px',
                  marginTop: '3px',
                }}
              />
            </div>

            <EventCalendarBasic
              properties={this.props.properties}
              siteEvents={this.props.siteEvents}
              onPropertySelect={this.onPropertySelect}
              onSelectEvent={this.toggleEventDetails}
              onSelectSlot={(slotInfo) =>
                this.toggleAddEvent({
                  start_date: slotInfo.start,
                  end_date: slotInfo.end,
                  email_tenants: true,
                  show_to_tenants: true,
                })
              }
              handleRangeChange={this.handleRangeChange}
            />
          </div>
        </div>
        <ConfirmationDialog
          showDialog={this.state.confirmDelete}
          hideDialog={this.deleteConfirmation}
          userConfirmVerbiage={getTranslatedString('landlordPortal.calendarPage.delete')}
          dialogTitle={getTranslatedString('landlordPortal.calendarPage.deleteEvent')}
          dialogBodyVerbiage={getTranslatedString('landlordPortal.calendarPage.areYouSure')}
          userConfirmAction={this.deleteEvent}
        />
      </div>
    );
  }
};

EventCalendar = connect(
  (store) => ({
    properties: store.landlordProperties.properties,
    eventDetails: store.siteEvent.eventDetails,
    siteEvents: store.siteEvent.siteEvents,
  }),
  { ...landlordPropertiesActions, ...siteEventActions, getEvent }
)(EventCalendar);

export default EventCalendar;
